import { useEffect, useState } from 'react';

import { VStack } from '@chakra-ui/react';
import { useLocation, useNavigate } from 'react-router-dom';

import PertaminaLogo from '@/assets/PertaminaLogo';
import { RootState } from '@/redux/store';
import { useAppSelector } from '@/redux/hooks';
import GenericMenus from '../Menus/GenericMenus';

const Sidebar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const role = useAppSelector((state: RootState) => state.account.roleName);
    const isReviewer = useAppSelector((state: RootState) => state.account.isReviewer);
    const totalNew = useAppSelector((state: RootState) => state.notification.totalNew);
    const menus = useAppSelector((state: RootState) => state.menu.menus);

    const [menuStatesGeneric, setMenuStatesGeneric] = useState<Record<string, boolean>>({});

    const handleNav = (item: string) => {
        navigate(item);
    };

    const handleOpenSubMenuGeneric = (menu: string) => {
        setMenuStatesGeneric((prevState) => ({
            ...prevState,
            [menu]: !prevState[menu as keyof typeof prevState],
        }));
    };

    const handleNavToFirstMenu = () => {
        const firstRoute = menus[0]?.isParent ? menus[0]?.children[0]?.url : menus[0]?.url;
        navigate(firstRoute || '/');
    };

    useEffect(() => {
        const { pathname } = location;

        if (pathname.includes('manage-invoices')) {
            setMenuStatesGeneric((prevState) => ({
                ...prevState,
                manageinvoices: true
            }));
        } else {
            setMenuStatesGeneric((prevState) => ({
                ...prevState,
                manageinvoices: false
            }));
        }

        if (pathname.includes('user-management')) {
            setMenuStatesGeneric((prevState) => ({
                ...prevState,
                usermanagement: true
            }));
        } else {
            setMenuStatesGeneric((prevState) => ({
                ...prevState,
                usermanagement: false
            }));
        }

        if (pathname.includes('settings')) {
            setMenuStatesGeneric((prevState) => ({
                ...prevState,
                settings: true
            }));
        } else {
            setMenuStatesGeneric((prevState) => ({
                ...prevState,
                settings: false
            }));
        }
    }, [location]);

    return (
        <VStack
            as="nav"
            color="white"
            p="5"
            pl={0}
            spacing="5"
            align="stretch"
            className='sidebar'
            width='350px'
            overflowY="auto"
        >
            <div style={{ display: 'flex', flexDirection: 'row', paddingLeft: 19 }}>
                <PertaminaLogo style={{ cursor: 'pointer' }} onClick={handleNavToFirstMenu} />
                {/*<Heading size="md" color='#000' style={{ marginTop: 6, marginLeft: 8, cursor: 'pointer' }} onClick={handleNavToFirstMenu}>INSPEKTA</Heading>*/}
            </div>
            <VStack align="stretch" marginTop="5">
                <GenericMenus
                    opened={menuStatesGeneric}
                    location={location}
                    handleNav={handleNav}
                    handleOpenSubMenuGeneric={handleOpenSubMenuGeneric}
                    totalNew={totalNew}
                    menus={menus}
                    isReviewer={isReviewer}
                    role={role}
                />
                {/* {role === 'super admin' && (
                    <SuperAdminMenus
                        opened={menuStates.opened}
                        openedUserManagement={menuStates.openedUserManagement}
                        openedSettings={menuStates.openedSettings}
                        location={location}
                        handleNav={handleNav}
                        handleOpenSubMenu={() => handleOpenSubMenu('opened')}
                        handleOpenSubMenuUserManagement={() => handleOpenSubMenu('openedUserManagement')}
                        handleOpenSubMenuSettings={() => handleOpenSubMenu('openedSettings')}
                        totalNew={totalNew}
                        menus={menus}
                    />
                )} */}

                {/* {role === 'inspecting company' && (
                    <InspectorMenus location={location} handleNav={handleNav} openedSettings={menuStates.openedSettings} handleOpenSubMenuSettings={() => handleOpenSubMenu('openedSettings')} isReviewer={isReviewer} totalNew={totalNew} />
                )} */}

                {/* {role === 'ship operator' && (
                    <ShipOwnerMenus location={location} handleNav={handleNav} openedSettings={menuStates.openedSettings} handleOpenSubMenuSettings={() => handleOpenSubMenu('openedSettings')} totalNew={totalNew} />
                )}

                {role === 'admin finance' && (
                    <AdminFinanceMenus location={location} handleNav={handleNav} opened={menuStates.opened} handleOpenSubMenu={() => handleOpenSubMenu('opened')} openedSettings={menuStates.openedSettings} handleOpenSubMenuSettings={() => handleOpenSubMenu('openedSettings')} totalNew={totalNew} />
                )}

                {role === 'requestor' && (
                    <RequestorMenus location={location} handleNav={handleNav} totalNew={totalNew} />
                )} */}
            </VStack>
        </VStack>
    );
};

export default Sidebar;
